import fireDataLayerPush from './fireDataLayerPush'
import { TRAVEL_CARD_PRODUCT_CODES } from '../travel-cards/specialTravelCardGroup'

/** "250.00" -> "250" - GBP, no symbol, no decimals, as the spec reports it */
export const toTopUpAmount = price => {
  const amount = Number(price)
  return price !== '' && price !== null && Number.isFinite(amount)
    ? String(Math.round(amount))
    : ''
}

/** The discount level shown against a top-up amount, as the Add Credit tab labels it */
export const getTopUpDiscountLevel = price => {
  const amount = toTopUpAmount(price)
  if (amount === '250') return '1'
  if (amount === '500') return '2'
  return '3'
}

export const isTravelCardRate = productCode =>
  !!TRAVEL_CARD_PRODUCT_CODES[productCode]

// The API returns message text but no error codes of its own, so a failed
// request reports its HTTP status - never the message (spec Rule 4)
export const getErrorCode = err =>
  err?.response?.status ? String(err.response.status) : 'none'

export const pushTopUpStart = price =>
  fireDataLayerPush('travel_card_top_up_start', {
    top_up_amount: toTopUpAmount(price),
    discount_level: getTopUpDiscountLevel(price),
  })

export const pushTravelCardError = ({
  flow,
  step,
  errorType,
  errorField = 'none',
  errorCode = 'none',
  topUpAmount = '',
}) =>
  fireDataLayerPush('travel_card_error', {
    travel_card_flow: flow,
    travel_card_step: step,
    error_type: errorType,
    error_field: errorField,
    error_code: errorCode,
    ...(flow === 'top_up' && topUpAmount ? { top_up_amount: topUpAmount } : {}),
  })
